/**
 * @Author: lifuzhao
 * @Date: 2019-07-11
 * @Project: driver
 */
import dayjs from 'dayjs'

let token = sessionStorage.getItem('token') || ''
let user = sessionStorage.getItem('user') || ''
let loginTime = sessionStorage.getItem('loginTime') || ''
let grade = sessionStorage.getItem('grade') || ''
if (!dayjs(loginTime).isValid()) {
  loginTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
}
export default {
  token: token
  , user: user
  , loginTime: loginTime
  , grade: grade
  , orderDetailData: {}
  , orderRouteData: {}
  , couponList: []
}
